{
  "point": "點數",
  "points": "點數",
  "credits": "消費獎勵",
  "loyaltyCredit": "忠誠消費獎勵",
  "statusPoints": "狀態點數",
  "balancePoints": "可消費的點數",
  "edit": "編輯",
  "delete": "刪除",
  "copyOf": "{value} 副本",
  "numberedCopyOf": "副本：{index}/{value}",
  "total": "總計",
  "uplift": "提升",
  "approveBtn.label": "確定",
  "cancelBtn.label": "取消",
  "createBtn.label": "建立",
  "saveBtn.label": "儲存",
  "searchBtn.label": "搜尋",
  "updateBtn.label": "更新",
  "applyBtn.label": "套用",
  "addNewPlanBtn.label": "新增計劃",
  "launchPlanBtn.label": "啟動計劃",
  "toOverviewBtn.label": "移至概觀",
  "collapseBtn.label": "收合",
  "extendBtn.label": "明細 ",
  "updateAndSave.label": "更新並儲存",
  "pleaseConfirmBtn.label": "確認",
  "closeBtn.label": "關閉",
  "resetBtn.label": "重設",
  "confirmBtn.label": "確認",
  "status.inactive": "未啟用",
  "status.active": "啟用中",
  "status.deactivated": "已停用",
  "status.scheduled": "已排程",
  "status.expired": "已過期",
  "status.readyToUse": "準備使用",
  "status.readyToLaunch": "準備啟動",
  "status.empty": "空白",
  "status.activity.pending": "待處理",
  "status.activity.confirmed": "已確認",
  "status.activity.expired": "已過期",
  "status.activity.canceled": "已取消",
  "status.activity.removed": "已移除",
  "status.default": "預設",
  "action.promotion": "促銷",
  "action.referral": "推薦",
  "action.action": "行動",
  "tiers.numberOfPurchases.plural.zero": "{number} 次購買",
  "tiers.numberOfPurchases.plural.one": "{number} 次購買",
  "tiers.numberOfPurchases.plural.two": "{number} 次購買",
  "tiers.numberOfPurchases.plural.few": "{number} 次購買",
  "tiers.numberOfPurchases.plural.many": "{number} 次購買",
  "tiers.numberOfPurchases.plural.other": "{number} 次購買",
  "validity.unlimited": "無限制",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.one": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.two": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.few": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.many": "{number} 天",
  "validity.limitedFromEarn.value.days.plural.other": "{number} 天",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} 週",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} 週",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} 週",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} 週",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} 週",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} 週",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} 個月",
  "validity.limitedFromEarn.value.months.plural.one": "{number} 個月",
  "validity.limitedFromEarn.value.months.plural.two": "{number} 個月",
  "validity.limitedFromEarn.value.months.plural.few": "{number} 個月",
  "validity.limitedFromEarn.value.months.plural.many": "{number} 個月",
  "validity.limitedFromEarn.value.months.plural.other": "{number} 個月",
  "days": "天",
  "dayInMonth": "天",
  "month": "月",
  "months.1": "一月",
  "months.2": "二月",
  "months.3": "三月",
  "months.4": "四月",
  "months.5": "五月",
  "months.6": "六月",
  "months.7": "七月",
  "months.8": "八月",
  "months.9": "九月",
  "months.10": "十月",
  "months.11": "十一月",
  "months.12": "十二月",
  "form.missingSettingsAlert": "請先確保您輸入所有必要資訊，再儲存並繼續下一步。",
  "noResults.title": "找不到結果。",
  "noResults.text": "沒有符合搜尋 \"{text}\" 的結果。",
  "alertContainer.editModeAlert.message": "您正在編輯忠誠計劃的下一個版本。啟動此新版本後，您的變更將生效。 ",
  "alertContainer.liveModeAlert.message.linkText": "深入瞭解",
  "alertContainer.liveModeAlert.message": "若要編輯層級、固定和其他福利，請從忠誠管理選擇 [更新並啟動]，然後切換至 [編輯下一個版本]。{link}",
  "card.isRoadmap.text": "藍圖",
  "catalogSelector.tooManyResults.title": "此搜尋的結果過多。 ",
  "catalogSelector.tooManyResults.text": "請再次嘗試使用更特定的關鍵字搜尋以縮小結果。",
  "catalogSelector.errorAlert": "發生錯誤，請再試一次。",
  "catalogSelector.searchPlaceholder.byItem": "搜尋特定產品。",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "選擇您要促銷的特定品牌或種類。",
  "catalogSelector.checkAllItems.label": "選擇全部",
  "catalogSelector.showAllSelections.label": "僅顯示所選項目。",
  "catalogSelector.cancelBtn.label": "關閉",
  "catalogSelector.saveBtn.label": "套用並儲存",
  "catalogSelector.brands.plural.zero": "{number} 個品牌",
  "catalogSelector.brands.plural.one": "{number} 個品牌",
  "catalogSelector.brands.plural.two": "{number} 個品牌",
  "catalogSelector.brands.plural.few": "{number} 個品牌",
  "catalogSelector.brands.plural.many": "{number} 個品牌",
  "catalogSelector.brands.plural.other": "{number} 個品牌",
  "catalogSelector.category.plural.zero": "{number} 個種類",
  "catalogSelector.category.plural.one": "{number} 個種類",
  "catalogSelector.category.plural.two": "{number} 個種類",
  "catalogSelector.category.plural.few": "{number} 個種類",
  "catalogSelector.category.plural.many": "{number} 個種類",
  "catalogSelector.category.plural.other": "{number} 個種類",
  "catalogSelector.product.plural.zero": "{number} 個產品",
  "catalogSelector.product.plural.one": "{number} 個產品",
  "catalogSelector.product.plural.two": "{number} 個產品",
  "catalogSelector.product.plural.few": "{number} 個產品",
  "catalogSelector.product.plural.many": "{number} 個產品",
  "catalogSelector.product.plural.other": "{number} 個產品",
  "confirmNavDialog.discardChanges.text": "請確保儲存變更。如果您離開此頁面，則任何未儲存的變更將遺失。",
  "confirmNavDialog.approveBtn.label": "確定",
  "confirmNavDialog.cancelBtn.label": "取消",
  "actionDashboard.overviewLinkText.referral": "移至推薦行動",
  "actionDashboard.editLinkText": "編輯計劃",
  "dashboardOptions.launchedAt": "計劃啟動於： ",
  "dashboardOptions.currentlyShowingLabel": "目前顯示：",
  "dashboardOptions.viewLabel": "檢視：",
  "masterActions.join.largeText": "加入忠誠",
  "masterActions.purchases.largeText": "購買",
  "status.inactive.tooltip": "未完成設定。",
  "status.inactive.tooltip.proomotionEnded": "此促銷未啟用，因此無法編輯。您可複製促銷或建立新促銷。",
  "status.inactive.tooltip.connectedToRewardPools": "兌換券集區 {name} 的狀態為 {status}。",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "檢查促銷日期。",
  "status.readyToUse.tooltip.promotion": "促銷已準備好可供使用。您可在成員錢包中自動顯示促銷，或在行銷活動編輯器中使用忠誠權杖將其附加至成員。",
  "status.readyToUse.tooltip.attachable": "行動已準備好可供使用，並可透過行銷活動編輯器使用忠誠權杖將其附加至聯絡人。",
  "status.active.tooltip.promotion": "此促銷為啟用中，可供成員使用。",
  "status.active.tooltip.attachable": "此行動為啟用中，您無法變更設定。若要編輯此行動，請先將其停用並等待指定到期日期。您也可複製行動、編輯副本，然後啟動副本作為新行動。",
  "status.active.tooltip.event": "此行動為啟用中。您可將行動連接至福利或自動化計劃。",
  "status.deactivated.tooltip.promotion": "您已停用此促銷，因此成員無法再使用。",
  "status.deactivated.tooltip.attachable": "您已停用此行動。若要編輯此行動，您必須等待指定到期日期。您也可複製行動、編輯副本，然後啟動副本作為新行動。",
  "editorTypePopup.title": "選擇編輯器類型",
  "editorTypePopup.text": "沒有專屬存取的客戶將看到凍結頁面。您可建立自動 HTML 頁面或使用我們其中一個範本。",
  "editorTypePopup.options.html.text": "建立自訂 HTML 頁面",
  "editorTypePopup.options.template.text": "從範本建立頁面",
  "fileInputField.uploadBtn.label": "上傳",
  "fileInputField.browseBtn.label": "瀏覽",
  "formStepsContainer.nextStep.text": "下一步",
  "formStepsContainer.prevStep.text": "上一步",
  "iconGallery.title": "忠誠圖示庫",
  "iconGallery.deleteDialog.headline": "您確定要刪除此圖示嗎？",
  "iconGallery.deleteDialog.content": "刪除此圖示後，便不會向成員顯示。請確保此圖示未連接至行動或兌換券。",
  "iconGallery.uploadResult.successMessage": "上傳成功。",
  "iconGallery.searchInput.placeholder": "按名稱搜尋圖示。",
  "iconGallery.fileUploader.tooltip": "<h3>上傳</h3><b>圖示上傳需求：</b></br>檔案：SVG 或 PNG</br>格式：正方形<br>尺寸上限：200x200 像素 <br>檔案大小上限：100 KB</br><sub>* 我們建議使用透明背景 </sub>。",
  "multiLangPopup.defaultNoticeText": "如果沒有合適語言設定，則您定義的主要語言是成員看到的預設語言。",
  "multiLangPopup.defaultTitle.currency": "幣別換算",
  "multiLangPopup.defaultTitle.language": "語言翻譯",
  "multiMarketSelector.multiSelectField.placeholder": "-- 選擇市場 --",
  "multiMarketSelector.selectField.placeholder": "-- 選擇市場 --",
  "multiPlanSelect.label": "選擇忠誠計劃 ",
  "preLaunchPopup.conditions.plan.title": "計劃設定",
  "preLaunchPopup.conditions.plan.text": "檢查忠誠計劃設定以確保正確設定所有項目並符合成員條款。",
  "preLaunchPopup.conditions.tiers.title": "層級和福利",
  "preLaunchPopup.conditions.tiers.text": "檢查是否已為所有成員正確設定層級，以及層級中的聯絡人分配是否與您的戰略相符。",
  "preLaunchPopup.conditions.rewards.title": "獎勵區",
  "preLaunchPopup.conditions.rewards.text": "檢查是否已為所有回應上傳足夠的兌換券代碼，以及是否已正確定義所有集區和兌換券有效性。",
  "preLaunchPopup.conditions.actions.title": "行動",
  "preLaunchPopup.conditions.actions.text": "檢查行動是否涵蓋您要使用的所有策略，以及是否已啟用所有預設行動。",
  "preLaunchPopup.title": "您確定要啟動忠誠計劃嗎？",
  "preLaunchPopup.text": "檢查設定以確保忠誠計劃準備啟動：",
  "timeValidityInput.radioLabel.days": "天",
  "timeValidityInput.radioLabel.weeks": "週",
  "timeValidityInput.radioLabel.months": "月",
  "ctaUrl": "CTA URL",
  "ctaText": "CTA 內文",
  "message": "訊息",
  "pageNotFound": "我們似乎找不到您要尋找的頁面。",
  "externalEventSetup.title": "外部忠誠事件",
  "externalEventSetup.name.label": "外部事件名稱",
  "externalEventSetup.description.label": "說明",
  "externalEventSetup.description.tooltip": "說明供內部使用，可協助您管理忠誠事件。",
  "pointsRatesFields.perDescriptor.points": "取得單位",
  "catalog.item.type.category.name": "種類",
  "catalog.item.type.brand.name": "品牌",
  "catalog.item.type.item.name": "產品",
  "catalog.item.type.itemId.name": "項目 ID",
  "exclusiveAccessOffers.options.fixedBenefit.title": "固定福利存取",
  "exclusiveAccessOffers.options.additionalBenefits.title": "其他福利存取",
  "exclusiveAccessOffers.options.action.title": "行動獎勵存取",
  "exclusiveAccessOffers.options.redemption.title": "點數存取",
  "exclusiveAccessOffers.options.redemptionForFree.title": "免費存取",
  "accessValidityType.options.unlimited.name": "存取的有效期間為無限期。",
  "accessValidityType.options.limitedFromEarn.name": "存取的有效期間為自成員取得時開始的有限期間。",
  "accessValidityType.options.fixedDate.name": "存取的有效期間為所有成員預先定義的期間。",
  "accessValidityType.options.disabled.fixedBenefit.name": "停用固定福利存取可用性。",
  "accessValidityType.options.disabled.additionalBenefit.name": "停用其他福利存取可用性。",
  "accessValidityType.options.disabled.reward.name": "停用行動獎勵存取可用性。",
  "createOfModify.options.create.name": "啟用優惠",
  "createOfModify.options.create.tooltip": "啟用新優惠時，啟用中優惠規則會重設，所有所選層級的成員可在定義優惠期間內使用。",
  "createOfModify.options.create.tooltip2": "啟用新優惠時，啟用中優惠限制會重設，所有所選層級的成員可在定義優惠期間內使用。 ",
  "createOfModify.options.modify.name": "編輯啟用中優惠",
  "createOfModify.options.modify.tooltip": "編輯啟用中優惠時，您的變更不會影響已兌換此優惠的成員。",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "專屬設定",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "凍結頁面",
  "exclusiveAccessFormSteps.redemptionValue.title": "存取和優惠",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "啟用",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "可消費的 {{points_name}}",
  "activityElementPointsText.status": "狀態 {{points_name}}",
  "activityElementPointsText.cashback": "現金回饋",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "一次性兌換券",
  "voucherTypeText.yearly": "多次使用兌換券",
  "exclusiveAccessTypeText.permanent": "永久專屬存取",
  "exclusiveAccessTypeText.limitedTerm": "限時專屬存取",
  "mainTabs.dashboard.title": "儀表板",
  "mainTabs.actions.title": "行動",
  "mainTabs.rewards.title": "獎勵",
  "mainTabs.tiers.title": "層級",
  "mainTabs.loyaltyWallet.title": "忠誠錢包",
  "mainTabs.memberProfiles.title": "成員設定檔",
  "mainTabs.externalEvents.title": "外部事件",
  "mainTabs.planSettings.title": "計劃設定",
  "mainTabs.vouchers.title": "兌換券",
  "mainTabs.exclusiveAccesss.title": "專屬存取",
  "mainTabs.loyaltyManagement.title": "忠誠管理",
  "mainTabs.security.title": "忠誠組態",
  "actionTabs.purchases.title": "購買",
  "actionTabs.promotions.title": "促銷",
  "actionTabs.engagements.title": "互動",
  "actionTabs.events.title": "事件",
  "actionTabs.referral.title": "推薦",
  "actionTabs.join.title": "加入忠誠",
  "tierTabs.tiers.title": "層級",
  "tierTabs.fixedBenefits.title": "固定福利",
  "tierTabs.additionalBenefits.title": "其他福利",
  "tierTabs.contactDistribution.title": "分配圖表",
  "managementTabs.accountSettings.title": "帳戶設定",
  "managementTabs.languageAndCurrency.title": "語言和幣別",
  "managementTabs.planSettings.title": "計劃設定",
  "managementTabs.cashbackSettings.title": "現金回饋設定",
  "managementTabs.membershipSettings.title": "會員設定",
  "managementTabs.updateAndLaunch.title": "更新並啟動",
  "onboardingTabs.accountSettings.title": "計劃建立",
  "onboardingTabs.activation.title": "啟用",
  "customerCalcPeriod.options.1.name": "過去 30 天",
  "customerCalcPeriod.options.2.name": "過去 60 天",
  "customerCalcPeriod.options.3.name": "過去 90 天",
  "customerCalcPeriod.options.6.name": "過去 6 個月",
  "customerCalcPeriod.options.12.name": "過去 12 個月",
  "planType.options.points.name": "點數和兌換",
  "planType.options.points_and_benefits.name": "點數和福利",
  "planType.options.spend.name": "消費和福利",
  "planType.options.points.tooltip": "以點數為基礎的計劃，其中包含單一或多層級和點數兌換。",
  "planType.options.points_and_benefits.tooltip": "以點數為基礎的計劃，其中包含多層級和福利，沒有點數兌換。",
  "planType.options.spend.tooltip": "以消費為基礎的計劃，其中包含單一或多層級和福利，沒有點數但有現金回饋選項規則。以消費為基礎的計劃僅管理一個幣別；如果您管理多個幣別，則必須為每個幣別管理個別計劃。",
  "pointsAllocatopmDelay.options.1.name": "24 小時",
  "pointsAllocatopmDelay.options.2.name": "48 小時",
  "pointsAllocatopmDelay.options.3.name": "72 小時",
  "pointsAllocatopmDelay.options.7.name": "7 天",
  "pointsAllocatopmDelay.options.14.name": "14 天",
  "pointsAllocatopmDelay.options.21.name": "21 天",
  "pointsAllocatopmDelay.options.30.name": "30 天",
  "pointsAllocatopmDelay.options.40.name": "40 天",
  "tierCalculationType.options.endOfYear.name": " 層級計算每 [X 年] 的 12 月 31 日進行一次。",
  "tierCalculationType.options.endOfYear.tooltip": "每 [x 年] 的固定日期計算層級。升級至較高層級的成員會在定義期間內保持其層級狀態。",
  "tierCalculationType.options.afterJoin.name": "層級計算自成員進入層級日期起的 [X 個月] 進行。",
  "tierCalculationType.options.afterJoin.tooltip": "層級計算日期可能因成員的層級進度而有所不同。升級至較高層級的成員會至少在定義期間內保持其層級狀態。",
  "tierCalculationType.options.endOfYear.spend.tooltip": "計算層級時，忠誠消費獎勵會重設，但在下次計算前，成員會保持其狀態。",
  "tierCalculationType.options.noDropout.name": "未計算層級。成員不需要符合需求即可保持此層級。",
  "tierCalculationType.options.noDropout.tooltip": "僅當升級層級時才會收集點數。",
  "statusPointsExpirationType.options.tierCalc.name": "狀態點數會在層級計算日期過期並重設。",
  "statusPointsExpirationType.options.tierCalc.tooltip": "計算層級時，便會重設，但在下次計算前，成員會保持其狀態。",
  "statusPointsExpirationType.options.fromEarn.name": "狀態點數會自成員取得點數日期起的每 [X 個月] 過期並重設一次。",
  "statusPointsExpirationType.options.fromEarn.tooltip": "計算層級時，僅會計算該天的有效點數。成員會保持其狀態或降至較低層級。",
  "statusPointsExpirationType.options.never.name": "狀態點數永不過期。",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "忠誠消費獎勵會在計算層級的日期過期並重設。",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "計算忠誠消費獎勵時，便會重設，但在下次計算前，成員會保持其狀態。",
  "loyaltyCreditExpirationType.options.fromEarn.name": "忠誠消費獎勵會自成員取得消費獎勵日期起的每 [X 個月] 過期並重設。 ",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "計算層級時，僅會計算該天的有效忠誠消費獎勵。成員會保持其狀態或降至較低層級。",
  "optIn.options.invitation.name": "已邀請所有聯絡人加入忠誠計劃。",
  "optIn.options.automatic.name": "所有聯絡人會自動成為忠誠成員。",
  "historicalBalancePoints.options.keep.name": "使用消費點兌換獎勵。",
  "historicalBalancePoints.options.keep.tooltip": "此選項激勵成員兌換點數以取得獎勵。",
  "historicalBalancePoints.options.remove.name": "不要使用消費點兌換獎勵。",
  "historicalBalancePoints.options.remove.tooltip": "消費點會重設，成員必須取得新點數才能進行兌換。",
  "currencyIdentifierSigh.options.symbol.name": "幣別符號",
  "currencyIdentifierSigh.options.symbol.tooltip": "範例：$500",
  "currencyIdentifierSigh.options.code.name": "ISO 幣別代碼",
  "currencyIdentifierSigh.options.code.tooltip": "範例：500USD",
  "currencyIdentifierSigh.options.none.name": "不含識別碼",
  "formStepRewards.options.poolSettings.title": "集區設定",
  "formStepRewards.options.uploadFile.title": "上傳檔案",
  "formStepRewards.options.redemptionValue.title": "優惠設定",
  "formStepRewards.options.validity.title": "有效性",
  "specialTiers.redemptopmSettings.all.name": "針對所有層級使用相同設定，已覆寫個別層級值。",
  "voucherValidityType.options.unlimited.name": "兌換券的有效期間為無限期。",
  "voucherValidityType.options.limitedFromEarn.name": "兌換券的有效期間為自成員取得兌換券時開始的有限期間。",
  "voucherValidityType.options.fixedDate.name": "兌換券的有效期間為所有成員預先定義的期間。",
  "redemptionLimit.options.noLimit.name": "定期自動向成員顯示此優惠。",
  "redemptionLimit.options.noLimit.tooltip": "如果您為層級啟用切換，兌換優惠會顯示在忠誠錢包中且沒有兌換限制。",
  "redemptionLimit.options.limitMember.name": "選擇每個成員可在定義期間兌換此優惠兌換券的次數。",
  "exclusiveAccessExclusivityType.options.name.fixed": "永久專屬",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "有限期限專屬",
  "exclusiveAccessExclusivityType.options.name.limited": "有限專屬",
  "editorContentTextDefaultValues.tag": "專屬存取",
  "editorContentTextDefaultValues.firstHeader": "<strong>提前黑色星期五</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>特價</strong>",
  "editorContentTextDefaultValues.middleText": "為我們忠誠成員提供專屬黑色星期五優惠。千萬不要錯過，立即加入忠誠計劃！",
  "editorContentTextDefaultValues.actionTopText": "還不是成員？加入我們的忠誠計劃並開始取得獎勵。",
  "editorContentTextDefaultValues.leftButton": "加入忠誠",
  "editorContentTextDefaultValues.rightButton": "改日",
  "editorContentTextDefaultValues.actionBottomText": "<span>已是成員？ <u>請登入</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "為我們忠誠客戶提供專屬優惠。千萬不要錯過，立即加入我們的忠誠計劃！",
  "editorContentTextDefaultValues.actionTopText.mobile": "還不是成員？加入我們的忠誠計劃。",
  "accessUrlType.options.exactUrl.name": "凍結並提供此頁面的專屬存取：",
  "accessUrlType.options.startsWithUrl.name": "凍結並提供以此 URL 開頭的所有頁面專屬存取：",
  "formStepsContainer.tierSettings.title": "層級設定",
  "formStepsContainer.purchaseBenefits.title": "購買福利",
  "formStepsContainer.visibility.title": "可見度",
  "tierDropout.options.yes.name": "是，已計算此層級，成員必須符合需求才能保持在此層級。",
  "tierDropout.options.no.name": "否，此層級沒有退出情境。",
  "fixedBenfitType.options.oneTimeVoucher.name": "一次性兌換券",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "固定年度兌換券 (需要多次使用代碼)。",
  "fixedBenfitType.options.eventAction.name": "事件",
  "fixedBenfitType.options.exclusiveAccess.name": "專屬存取",
  "fixedBenfitType.options.custom.name": "自訂 (由您獨立提供)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "多次使用兌換券 (需要多次使用代碼)。",
  "tierTypeOptions.regular.name": "以點數為基礎",
  "tierTypeOptions.invite.name": "僅邀請",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "深入瞭解",
  "tierTypeOptions.invite.tooltip": "僅受邀或付費成員可屬於層級，管理您的付款和會員；若要將成員新增至此層級，請使用忠誠 API 或成員設定檔。{learnMoreLink}。",
  "tierTypeOptions.spend.name": "以消費為基礎",
  "exclusiveAccess.cardLabels.permanent": "永久",
  "exclusiveAccess.cardLabels.limtedTerm": "有限期限",
  "cards.filterBar.moreFiltersButton": "更多篩選器",
  "catalogSelector.selected.single": "已選擇 {items}",
  "catalogSelector.selected.multiple": "已選擇 {items} 和 {lastItems}",
  "iconGallery.uploadResult.failMessage": "上傳期間發生錯誤。請確保檔案符合要求。\n{showFileList,select,true{{failed}/{total} 個失敗：{failedDetails}} 其他{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "對於每個",
  "activityElementMultiuplyPointsText.double": "兩倍",
  "activityElementMultiuplyPointsText.triple": "三倍"
}
